/** @jsx jsx */
import { Box, Flex, Heading, Paragraph, Stack } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import emptyListSvg from "./empty-list.svg";

interface EmptyListProps {
  header: string;
  subheader?: string;
}

export const EmptyList: FC<EmptyListProps> = ({ header, subheader }) => {
  return (
    <Box
      sx={{
        padding: "96px",
      }}>
      <Stack gap="md">
        <Flex alignItems="center" justifyContent="center">
          <img src={emptyListSvg} />
        </Flex>

        <Flex flexDirection="column" alignItems="center">
          <Heading size="h-sm">{header}</Heading>
          <Flex mt="xxs">
            <Paragraph size="p-md" color="n700">
              {subheader}
            </Paragraph>
          </Flex>
        </Flex>
      </Stack>
    </Box>
  );
};
